/*!
 * name ZJX 作品资源审核
 * Copyright 2018-2019
 */
<template>
  <div class>
    <div class="public_nav">
      <div
        :class="[item.class,hoverArr[index]]"
        :key="index"
        v-for="(item,index) in navList"
        @click="tabMuth(item)"
      >{{item.name}}</div>
    </div>

    <div class="submit_box" v-if="pstatus == 1">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label>
          <el-select v-model="formInline.region1" placeholder="请选择" clearable>
            <el-option label="教师作品" value="teacher"></el-option>
            <el-option label="学生作品" value="student"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <template>
      <el-table
        :data="tableData"
        style="width: 100%;font-size: 12px"
        :default-sort="{prop: 'date', order: 'descending'}"
      >
        <el-table-column prop="title" :label="pstatus == 1 ? '作品标题' : '资源标题'" width="200"></el-table-column>
        <el-table-column prop="attachments" label="文件" width="190">
          <template slot-scope="scope">
            <p v-for="(item,index) in scope.row.attachments" :key="index">
              {{item.file_name}}
            </p>
          </template>
        </el-table-column>
        <el-table-column prop="author.name" :label="pstatus == 1 ? '创作者' : '上传者'" width="120"></el-table-column>
        <el-table-column prop="created_at" label="日期" width="150"></el-table-column>
        <el-table-column prop="btn" label width="100">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        background
        layout="prev, pager, next"
        :page-size="pageSize"
        :total="totalData"
        @current-change="pageNumberChange"
      ></el-pagination>
    </template>
  </div>
</template>

<script>
import publicNav from "@/components/publicnav"; //引入公共页签
import cacheUtils from "@/common/cacheUtils"; //调用缓存
import apiInterface from "@/api/index"; //接口

export default {
  data() {
    return {
      //查询
      formInline: {
        region1: "",
        region2: ""
      },
      //表格数据
      tableData: [],
      navList: [
        {
          id: 1,
          name: "作品审核",
          class: "public_nav_tab"
        },
        {
          id: 2,
          name: "资源审核",
          class: "public_nav_tab"
        }
      ],
      hoverArr: ["cur_hover_t1", ""],
      totalData: 0, //数据总数
      pageSize: 10, //每页条数
      pstatus: 1
    };
  },
  computed: {},
  components: {
    publicNav
  },
  mounted() {},
  methods: {
    //查询
    onSubmit() {
      console.log("submit!");
      this.reviewWorks(1, (this.pstatus = 1))
    },
    handleEdit(index, row) {
      if ("type_id" in row.author) {
        if (row.author.type_id == 1) {
          this.$router.push({
            path: "/workshopDetails",
            query: {
              id: row.id
            }
          });
        } else {
          this.$router.push({ // 学生作品详情
            path: "/studentDetails",
            query: {
              id: row.id
            }
          });
        }
      } else {
        this.$router.push({
          path: "/resourceDetails1",
          query: {
            id: row.id,
            text:'资源'
          }
        });
      }
    },
    //tab切换调用ajax
    tabMuth(item) {
      let id = item.id - 1;
      this.hoverArr = this.hoverArr.map((item, index) => {
        return id == index ? "cur_hover_t1" : "";
      });
      if (item.id == 1) {
        this.reviewWorks(1, (this.pstatus = 1));
      } else {
        this.reviewWorks(1, (this.pstatus = 2));
      }
    },
    //分页页码改变
    pageNumberChange(pageNumber) {
      this.reviewWorks(pageNumber, this.pstatus);
    },
    //作品审核列表
    async reviewWorks(pages = 1, status) {
        let data = {
         page: pages,
       }
       if(this.formInline.region1){

        data.author_type = this.formInline.region1
      }
      try {
        let pdata = await this.$xhr.get(
          status == 1 ? apiInterface.inverification : apiInterface.verification,
          {
            params:data
          }
        );
        this.tableData = pdata.data;
        this.totalData = pdata.meta.pagination.total;
      } catch (error) {
        this.$message.error(error.message);
      }
    }
  },
  created() {
    this.reviewWorks(1, 1);
  },
  watch: {},
  props: {}
};
</script>

<style lang="scss" >
.personal_center_menu_right .el-table .cell {
  text-align: center;
}
.el-button--mini {
  border: #15c1e4 solid 1px;
  color: #15c1e4;
}
.el-pagination {
  text-align: center;
  padding: 80px 0;
}
.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
  font-weight: 100;
  color: #66686b;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #15c1e4;
}
.public_nav {
  height: 40px;
  border-bottom: 2px solid #15c1e4;
  .public_nav_tab {
    height: 40px;
    width: 120px;
    background: #eeeeee;
    line-height: 40px;
    text-align: center;
    font-size: 15px;
    color: #000;
    float: left;
    cursor: pointer;
  }
}
.cur_hover_t1 {
  background: #15c1e4 !important;
  color: #fff !important;
  font-weight: bold;
}
</style>

